import { render } from "./WalletTrades.vue?vue&type=template&id=ba14c65a"
import script from "./WalletTrades.vue?vue&type=script&lang=js"
export * from "./WalletTrades.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/WalletTrades.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba14c65a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba14c65a', __exports__)) {
    api.reload('ba14c65a', __exports__)
  }
  
  module.hot.accept("./WalletTrades.vue?vue&type=template&id=ba14c65a", () => {
    api.rerender('ba14c65a', render)
  })

}


export default __exports__